var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _defs;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgLogoLight = function SvgLogoLight(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 28,
    height: 15,
    fill: "none",
    viewBox: "0 0 28 15",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "url(#paint0_linear_5857_34274)",
    fillRule: "evenodd",
    d: "m13.22 12.64 7.49-7.511c.1-.1.269-.08.34.043l4.018 6.804a1.07 1.07 0 0 0 1.971-.745l-1.47-7.665a2.605 2.605 0 0 0-4.115-1.597.243.243 0 0 1-.339-.045A4.8 4.8 0 0 0 18.501.152c-1.6-.43-3.48.071-4.663 1.257L6.348 8.92c-.1.1-.268.08-.34-.043L1.99 2.074a1.07 1.07 0 0 0-1.97.745l1.47 7.664a2.605 2.605 0 0 0 4.114 1.597c.106-.08.26-.06.34.046a4.8 4.8 0 0 0 2.613 1.772c1.783.478 3.391.018 4.663-1.257m-6.043-2.098a.216.216 0 0 0-.033.263l.005.009a3.081 3.081 0 0 0 4.835.61l7.895-7.916a.216.216 0 0 0 .034-.263l-.005-.01a3.081 3.081 0 0 0-4.835-.61zm17.204-3.967c.045.238-.276.36-.4.15l-1.723-2.918a.216.216 0 0 1 .034-.263l.102-.103a.872.872 0 0 1 1.472.451zm-21.704.9c-.046-.239.275-.36.399-.151l1.723 2.918a.216.216 0 0 1-.033.263l-.102.103a.872.872 0 0 1-1.473-.45z",
    clipRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#paint1_linear_5857_34274)",
    fillRule: "evenodd",
    d: "m13.22 12.64 7.49-7.511c.1-.1.269-.08.34.043l4.018 6.804a1.07 1.07 0 0 0 1.971-.745l-1.47-7.665a2.605 2.605 0 0 0-4.115-1.597.243.243 0 0 1-.339-.045A4.8 4.8 0 0 0 18.501.152c-1.6-.43-3.48.071-4.663 1.257L6.348 8.92c-.1.1-.268.08-.34-.043L1.99 2.074a1.07 1.07 0 0 0-1.97.745l1.47 7.664a2.605 2.605 0 0 0 4.114 1.597c.106-.08.26-.06.34.046a4.8 4.8 0 0 0 2.613 1.772c1.783.478 3.391.018 4.663-1.257m-6.043-2.098a.216.216 0 0 0-.033.263l.005.009a3.081 3.081 0 0 0 4.835.61l7.895-7.916a.216.216 0 0 0 .034-.263l-.005-.01a3.081 3.081 0 0 0-4.835-.61zm17.204-3.967c.045.238-.276.36-.4.15l-1.723-2.918a.216.216 0 0 1 .034-.263l.102-.103a.872.872 0 0 1 1.472.451zm-21.704.9c-.046-.239.275-.36.399-.151l1.723 2.918a.216.216 0 0 1-.033.263l-.102.103a.872.872 0 0 1-1.473-.45z",
    clipRule: "evenodd"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#paint2_linear_5857_34274)",
    fillRule: "evenodd",
    d: "m13.22 12.64 7.49-7.511c.1-.1.269-.08.34.043l4.018 6.804a1.07 1.07 0 0 0 1.971-.745l-1.47-7.665a2.605 2.605 0 0 0-4.115-1.597.243.243 0 0 1-.339-.045A4.8 4.8 0 0 0 18.501.152c-1.6-.43-3.48.071-4.663 1.257L6.348 8.92c-.1.1-.268.08-.34-.043L1.99 2.074a1.07 1.07 0 0 0-1.97.745l1.47 7.664a2.605 2.605 0 0 0 4.114 1.597c.106-.08.26-.06.34.046a4.8 4.8 0 0 0 2.613 1.772c1.783.478 3.391.018 4.663-1.257m-6.043-2.098a.216.216 0 0 0-.033.263l.005.009a3.081 3.081 0 0 0 4.835.61l7.895-7.916a.216.216 0 0 0 .034-.263l-.005-.01a3.081 3.081 0 0 0-4.835-.61zm17.204-3.967c.045.238-.276.36-.4.15l-1.723-2.918a.216.216 0 0 1 .034-.263l.102-.103a.872.872 0 0 1 1.472.451zm-21.704.9c-.046-.239.275-.36.399-.151l1.723 2.918a.216.216 0 0 1-.033.263l-.102.103a.872.872 0 0 1-1.473-.45z",
    clipRule: "evenodd"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#paint3_linear_5857_34274)",
    fillRule: "evenodd",
    d: "m13.22 12.64 7.49-7.511c.1-.1.269-.08.34.043l4.018 6.804a1.07 1.07 0 0 0 1.971-.745l-1.47-7.665a2.605 2.605 0 0 0-4.115-1.597.243.243 0 0 1-.339-.045A4.8 4.8 0 0 0 18.501.152c-1.6-.43-3.48.071-4.663 1.257L6.348 8.92c-.1.1-.268.08-.34-.043L1.99 2.074a1.07 1.07 0 0 0-1.97.745l1.47 7.664a2.605 2.605 0 0 0 4.114 1.597c.106-.08.26-.06.34.046a4.8 4.8 0 0 0 2.613 1.772c1.783.478 3.391.018 4.663-1.257m-6.043-2.098a.216.216 0 0 0-.033.263l.005.009a3.081 3.081 0 0 0 4.835.61l7.895-7.916a.216.216 0 0 0 .034-.263l-.005-.01a3.081 3.081 0 0 0-4.835-.61zm17.204-3.967c.045.238-.276.36-.4.15l-1.723-2.918a.216.216 0 0 1 .034-.263l.102-.103a.872.872 0 0 1 1.472.451zm-21.704.9c-.046-.239.275-.36.399-.151l1.723 2.918a.216.216 0 0 1-.033.263l-.102.103a.872.872 0 0 1-1.473-.45z",
    clipRule: "evenodd"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#paint4_linear_5857_34274)",
    fillRule: "evenodd",
    d: "m13.22 12.64 7.49-7.511c.1-.1.269-.08.34.043l4.018 6.804a1.07 1.07 0 0 0 1.971-.745l-1.47-7.665a2.605 2.605 0 0 0-4.115-1.597.243.243 0 0 1-.339-.045A4.8 4.8 0 0 0 18.501.152c-1.6-.43-3.48.071-4.663 1.257L6.348 8.92c-.1.1-.268.08-.34-.043L1.99 2.074a1.07 1.07 0 0 0-1.97.745l1.47 7.664a2.605 2.605 0 0 0 4.114 1.597c.106-.08.26-.06.34.046a4.8 4.8 0 0 0 2.613 1.772c1.783.478 3.391.018 4.663-1.257m-6.043-2.098a.216.216 0 0 0-.033.263l.005.009a3.081 3.081 0 0 0 4.835.61l7.895-7.916a.216.216 0 0 0 .034-.263l-.005-.01a3.081 3.081 0 0 0-4.835-.61zm17.204-3.967c.045.238-.276.36-.4.15l-1.723-2.918a.216.216 0 0 1 .034-.263l.102-.103a.872.872 0 0 1 1.472.451zm-21.704.9c-.046-.239.275-.36.399-.151l1.723 2.918a.216.216 0 0 1-.033.263l-.102.103a.872.872 0 0 1-1.473-.45z",
    clipRule: "evenodd"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#paint5_linear_5857_34274)",
    fillRule: "evenodd",
    d: "m13.22 12.64 7.49-7.511c.1-.1.269-.08.34.043l4.018 6.804a1.07 1.07 0 0 0 1.971-.745l-1.47-7.665a2.605 2.605 0 0 0-4.115-1.597.243.243 0 0 1-.339-.045A4.8 4.8 0 0 0 18.501.152c-1.6-.43-3.48.071-4.663 1.257L6.348 8.92c-.1.1-.268.08-.34-.043L1.99 2.074a1.07 1.07 0 0 0-1.97.745l1.47 7.664a2.605 2.605 0 0 0 4.114 1.597c.106-.08.26-.06.34.046a4.8 4.8 0 0 0 2.613 1.772c1.783.478 3.391.018 4.663-1.257m-6.043-2.098a.216.216 0 0 0-.033.263l.005.009a3.081 3.081 0 0 0 4.835.61l7.895-7.916a.216.216 0 0 0 .034-.263l-.005-.01a3.081 3.081 0 0 0-4.835-.61zm17.204-3.967c.045.238-.276.36-.4.15l-1.723-2.918a.216.216 0 0 1 .034-.263l.102-.103a.872.872 0 0 1 1.472.451zm-21.704.9c-.046-.239.275-.36.399-.151l1.723 2.918a.216.216 0 0 1-.033.263l-.102.103a.872.872 0 0 1-1.473-.45z",
    clipRule: "evenodd"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#paint6_linear_5857_34274)",
    fillRule: "evenodd",
    d: "m13.22 12.64 7.49-7.511c.1-.1.269-.08.34.043l4.018 6.804a1.07 1.07 0 0 0 1.971-.745l-1.47-7.665a2.605 2.605 0 0 0-4.115-1.597.243.243 0 0 1-.339-.045A4.8 4.8 0 0 0 18.501.152c-1.6-.43-3.48.071-4.663 1.257L6.348 8.92c-.1.1-.268.08-.34-.043L1.99 2.074a1.07 1.07 0 0 0-1.97.745l1.47 7.664a2.605 2.605 0 0 0 4.114 1.597c.106-.08.26-.06.34.046a4.8 4.8 0 0 0 2.613 1.772c1.783.478 3.391.018 4.663-1.257m-6.043-2.098a.216.216 0 0 0-.033.263l.005.009a3.081 3.081 0 0 0 4.835.61l7.895-7.916a.216.216 0 0 0 .034-.263l-.005-.01a3.081 3.081 0 0 0-4.835-.61zm17.204-3.967c.045.238-.276.36-.4.15l-1.723-2.918a.216.216 0 0 1 .034-.263l.102-.103a.872.872 0 0 1 1.472.451zm-21.704.9c-.046-.239.275-.36.399-.151l1.723 2.918a.216.216 0 0 1-.033.263l-.102.103a.872.872 0 0 1-1.473-.45z",
    clipRule: "evenodd"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#paint7_linear_5857_34274)",
    fillRule: "evenodd",
    d: "m13.22 12.64 7.49-7.511c.1-.1.269-.08.34.043l4.018 6.804a1.07 1.07 0 0 0 1.971-.745l-1.47-7.665a2.605 2.605 0 0 0-4.115-1.597.243.243 0 0 1-.339-.045A4.8 4.8 0 0 0 18.501.152c-1.6-.43-3.48.071-4.663 1.257L6.348 8.92c-.1.1-.268.08-.34-.043L1.99 2.074a1.07 1.07 0 0 0-1.97.745l1.47 7.664a2.605 2.605 0 0 0 4.114 1.597c.106-.08.26-.06.34.046a4.8 4.8 0 0 0 2.613 1.772c1.783.478 3.391.018 4.663-1.257m-6.043-2.098a.216.216 0 0 0-.033.263l.005.009a3.081 3.081 0 0 0 4.835.61l7.895-7.916a.216.216 0 0 0 .034-.263l-.005-.01a3.081 3.081 0 0 0-4.835-.61zm17.204-3.967c.045.238-.276.36-.4.15l-1.723-2.918a.216.216 0 0 1 .034-.263l.102-.103a.872.872 0 0 1 1.472.451zm-21.704.9c-.046-.239.275-.36.399-.151l1.723 2.918a.216.216 0 0 1-.033.263l-.102.103a.872.872 0 0 1-1.473-.45z",
    clipRule: "evenodd"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#paint8_linear_5857_34274)",
    fillRule: "evenodd",
    d: "m13.22 12.64 7.49-7.511c.1-.1.269-.08.34.043l4.018 6.804a1.07 1.07 0 0 0 1.971-.745l-1.47-7.665a2.605 2.605 0 0 0-4.115-1.597.243.243 0 0 1-.339-.045A4.8 4.8 0 0 0 18.501.152c-1.6-.43-3.48.071-4.663 1.257L6.348 8.92c-.1.1-.268.08-.34-.043L1.99 2.074a1.07 1.07 0 0 0-1.97.745l1.47 7.664a2.605 2.605 0 0 0 4.114 1.597c.106-.08.26-.06.34.046a4.8 4.8 0 0 0 2.613 1.772c1.783.478 3.391.018 4.663-1.257m-6.043-2.098a.216.216 0 0 0-.033.263l.005.009a3.081 3.081 0 0 0 4.835.61l7.895-7.916a.216.216 0 0 0 .034-.263l-.005-.01a3.081 3.081 0 0 0-4.835-.61zm17.204-3.967c.045.238-.276.36-.4.15l-1.723-2.918a.216.216 0 0 1 .034-.263l.102-.103a.872.872 0 0 1 1.472.451zm-21.704.9c-.046-.239.275-.36.399-.151l1.723 2.918a.216.216 0 0 1-.033.263l-.102.103a.872.872 0 0 1-1.473-.45z",
    clipRule: "evenodd"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#paint9_linear_5857_34274)",
    fillRule: "evenodd",
    d: "m13.22 12.64 7.49-7.511c.1-.1.269-.08.34.043l4.018 6.804a1.07 1.07 0 0 0 1.971-.745l-1.47-7.665a2.605 2.605 0 0 0-4.115-1.597.243.243 0 0 1-.339-.045A4.8 4.8 0 0 0 18.501.152c-1.6-.43-3.48.071-4.663 1.257L6.348 8.92c-.1.1-.268.08-.34-.043L1.99 2.074a1.07 1.07 0 0 0-1.97.745l1.47 7.664a2.605 2.605 0 0 0 4.114 1.597c.106-.08.26-.06.34.046a4.8 4.8 0 0 0 2.613 1.772c1.783.478 3.391.018 4.663-1.257m-6.043-2.098a.216.216 0 0 0-.033.263l.005.009a3.081 3.081 0 0 0 4.835.61l7.895-7.916a.216.216 0 0 0 .034-.263l-.005-.01a3.081 3.081 0 0 0-4.835-.61zm17.204-3.967c.045.238-.276.36-.4.15l-1.723-2.918a.216.216 0 0 1 .034-.263l.102-.103a.872.872 0 0 1 1.472.451zm-21.704.9c-.046-.239.275-.36.399-.151l1.723 2.918a.216.216 0 0 1-.033.263l-.102.103a.872.872 0 0 1-1.473-.45z",
    clipRule: "evenodd"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#paint10_linear_5857_34274)",
    fillRule: "evenodd",
    d: "m13.22 12.64 7.49-7.511c.1-.1.269-.08.34.043l4.018 6.804a1.07 1.07 0 0 0 1.971-.745l-1.47-7.665a2.605 2.605 0 0 0-4.115-1.597.243.243 0 0 1-.339-.045A4.8 4.8 0 0 0 18.501.152c-1.6-.43-3.48.071-4.663 1.257L6.348 8.92c-.1.1-.268.08-.34-.043L1.99 2.074a1.07 1.07 0 0 0-1.97.745l1.47 7.664a2.605 2.605 0 0 0 4.114 1.597c.106-.08.26-.06.34.046a4.8 4.8 0 0 0 2.613 1.772c1.783.478 3.391.018 4.663-1.257m-6.043-2.098a.216.216 0 0 0-.033.263l.005.009a3.081 3.081 0 0 0 4.835.61l7.895-7.916a.216.216 0 0 0 .034-.263l-.005-.01a3.081 3.081 0 0 0-4.835-.61zm17.204-3.967c.045.238-.276.36-.4.15l-1.723-2.918a.216.216 0 0 1 .034-.263l.102-.103a.872.872 0 0 1 1.472.451zm-21.704.9c-.046-.239.275-.36.399-.151l1.723 2.918a.216.216 0 0 1-.033.263l-.102.103a.872.872 0 0 1-1.473-.45z",
    clipRule: "evenodd"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#paint11_radial_5857_34274)",
    fillRule: "evenodd",
    d: "m13.22 12.64 7.49-7.511c.1-.1.269-.08.34.043l4.018 6.804a1.07 1.07 0 0 0 1.971-.745l-1.47-7.665a2.605 2.605 0 0 0-4.115-1.597.243.243 0 0 1-.339-.045A4.8 4.8 0 0 0 18.501.152c-1.6-.43-3.48.071-4.663 1.257L6.348 8.92c-.1.1-.268.08-.34-.043L1.99 2.074a1.07 1.07 0 0 0-1.97.745l1.47 7.664a2.605 2.605 0 0 0 4.114 1.597c.106-.08.26-.06.34.046a4.8 4.8 0 0 0 2.613 1.772c1.783.478 3.391.018 4.663-1.257m-6.043-2.098a.216.216 0 0 0-.033.263l.005.009a3.081 3.081 0 0 0 4.835.61l7.895-7.916a.216.216 0 0 0 .034-.263l-.005-.01a3.081 3.081 0 0 0-4.835-.61zm17.204-3.967c.045.238-.276.36-.4.15l-1.723-2.918a.216.216 0 0 1 .034-.263l.102-.103a.872.872 0 0 1 1.472.451zm-21.704.9c-.046-.239.275-.36.399-.151l1.723 2.918a.216.216 0 0 1-.033.263l-.102.103a.872.872 0 0 1-1.473-.45z",
    clipRule: "evenodd"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#paint12_radial_5857_34274)",
    fillRule: "evenodd",
    d: "m13.22 12.64 7.49-7.511c.1-.1.269-.08.34.043l4.018 6.804a1.07 1.07 0 0 0 1.971-.745l-1.47-7.665a2.605 2.605 0 0 0-4.115-1.597.243.243 0 0 1-.339-.045A4.8 4.8 0 0 0 18.501.152c-1.6-.43-3.48.071-4.663 1.257L6.348 8.92c-.1.1-.268.08-.34-.043L1.99 2.074a1.07 1.07 0 0 0-1.97.745l1.47 7.664a2.605 2.605 0 0 0 4.114 1.597c.106-.08.26-.06.34.046a4.8 4.8 0 0 0 2.613 1.772c1.783.478 3.391.018 4.663-1.257m-6.043-2.098a.216.216 0 0 0-.033.263l.005.009a3.081 3.081 0 0 0 4.835.61l7.895-7.916a.216.216 0 0 0 .034-.263l-.005-.01a3.081 3.081 0 0 0-4.835-.61zm17.204-3.967c.045.238-.276.36-.4.15l-1.723-2.918a.216.216 0 0 1 .034-.263l.102-.103a.872.872 0 0 1 1.472.451zm-21.704.9c-.046-.239.275-.36.399-.151l1.723 2.918a.216.216 0 0 1-.033.263l-.102.103a.872.872 0 0 1-1.473-.45z",
    clipRule: "evenodd"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#paint13_radial_5857_34274)",
    fillRule: "evenodd",
    d: "m13.22 12.64 7.49-7.511c.1-.1.269-.08.34.043l4.018 6.804a1.07 1.07 0 0 0 1.971-.745l-1.47-7.665a2.605 2.605 0 0 0-4.115-1.597.243.243 0 0 1-.339-.045A4.8 4.8 0 0 0 18.501.152c-1.6-.43-3.48.071-4.663 1.257L6.348 8.92c-.1.1-.268.08-.34-.043L1.99 2.074a1.07 1.07 0 0 0-1.97.745l1.47 7.664a2.605 2.605 0 0 0 4.114 1.597c.106-.08.26-.06.34.046a4.8 4.8 0 0 0 2.613 1.772c1.783.478 3.391.018 4.663-1.257m-6.043-2.098a.216.216 0 0 0-.033.263l.005.009a3.081 3.081 0 0 0 4.835.61l7.895-7.916a.216.216 0 0 0 .034-.263l-.005-.01a3.081 3.081 0 0 0-4.835-.61zm17.204-3.967c.045.238-.276.36-.4.15l-1.723-2.918a.216.216 0 0 1 .034-.263l.102-.103a.872.872 0 0 1 1.472.451zm-21.704.9c-.046-.239.275-.36.399-.151l1.723 2.918a.216.216 0 0 1-.033.263l-.102.103a.872.872 0 0 1-1.473-.45z",
    clipRule: "evenodd"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#paint14_radial_5857_34274)",
    fillRule: "evenodd",
    d: "m13.22 12.64 7.49-7.511c.1-.1.269-.08.34.043l4.018 6.804a1.07 1.07 0 0 0 1.971-.745l-1.47-7.665a2.605 2.605 0 0 0-4.115-1.597.243.243 0 0 1-.339-.045A4.8 4.8 0 0 0 18.501.152c-1.6-.43-3.48.071-4.663 1.257L6.348 8.92c-.1.1-.268.08-.34-.043L1.99 2.074a1.07 1.07 0 0 0-1.97.745l1.47 7.664a2.605 2.605 0 0 0 4.114 1.597c.106-.08.26-.06.34.046a4.8 4.8 0 0 0 2.613 1.772c1.783.478 3.391.018 4.663-1.257m-6.043-2.098a.216.216 0 0 0-.033.263l.005.009a3.081 3.081 0 0 0 4.835.61l7.895-7.916a.216.216 0 0 0 .034-.263l-.005-.01a3.081 3.081 0 0 0-4.835-.61zm17.204-3.967c.045.238-.276.36-.4.15l-1.723-2.918a.216.216 0 0 1 .034-.263l.102-.103a.872.872 0 0 1 1.472.451zm-21.704.9c-.046-.239.275-.36.399-.151l1.723 2.918a.216.216 0 0 1-.033.263l-.102.103a.872.872 0 0 1-1.473-.45z",
    clipRule: "evenodd"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#paint15_linear_5857_34274)",
    fillRule: "evenodd",
    d: "m13.22 12.64 7.49-7.511c.1-.1.269-.08.34.043l4.018 6.804a1.07 1.07 0 0 0 1.971-.745l-1.47-7.665a2.605 2.605 0 0 0-4.115-1.597.243.243 0 0 1-.339-.045A4.8 4.8 0 0 0 18.501.152c-1.6-.43-3.48.071-4.663 1.257L6.348 8.92c-.1.1-.268.08-.34-.043L1.99 2.074a1.07 1.07 0 0 0-1.97.745l1.47 7.664a2.605 2.605 0 0 0 4.114 1.597c.106-.08.26-.06.34.046a4.8 4.8 0 0 0 2.613 1.772c1.783.478 3.391.018 4.663-1.257m-6.043-2.098a.216.216 0 0 0-.033.263l.005.009a3.081 3.081 0 0 0 4.835.61l7.895-7.916a.216.216 0 0 0 .034-.263l-.005-.01a3.081 3.081 0 0 0-4.835-.61zm17.204-3.967c.045.238-.276.36-.4.15l-1.723-2.918a.216.216 0 0 1 .034-.263l.102-.103a.872.872 0 0 1 1.472.451zm-21.704.9c-.046-.239.275-.36.399-.151l1.723 2.918a.216.216 0 0 1-.033.263l-.102.103a.872.872 0 0 1-1.473-.45z",
    clipRule: "evenodd"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#paint16_radial_5857_34274)",
    fillRule: "evenodd",
    d: "m13.22 12.64 7.49-7.511c.1-.1.269-.08.34.043l4.018 6.804a1.07 1.07 0 0 0 1.971-.745l-1.47-7.665a2.605 2.605 0 0 0-4.115-1.597.243.243 0 0 1-.339-.045A4.8 4.8 0 0 0 18.501.152c-1.6-.43-3.48.071-4.663 1.257L6.348 8.92c-.1.1-.268.08-.34-.043L1.99 2.074a1.07 1.07 0 0 0-1.97.745l1.47 7.664a2.605 2.605 0 0 0 4.114 1.597c.106-.08.26-.06.34.046a4.8 4.8 0 0 0 2.613 1.772c1.783.478 3.391.018 4.663-1.257m-6.043-2.098a.216.216 0 0 0-.033.263l.005.009a3.081 3.081 0 0 0 4.835.61l7.895-7.916a.216.216 0 0 0 .034-.263l-.005-.01a3.081 3.081 0 0 0-4.835-.61zm17.204-3.967c.045.238-.276.36-.4.15l-1.723-2.918a.216.216 0 0 1 .034-.263l.102-.103a.872.872 0 0 1 1.472.451zm-21.704.9c-.046-.239.275-.36.399-.151l1.723 2.918a.216.216 0 0 1-.033.263l-.102.103a.872.872 0 0 1-1.473-.45z",
    clipRule: "evenodd"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_5857_34274",
    x1: 22.604,
    x2: 26.375,
    y1: 4.412,
    y2: 2.508,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F8F4EB",
    stopOpacity: 0.2
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F8F4EB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_5857_34274",
    x1: 21.279,
    x2: 15.714,
    y1: 5.556,
    y2: 10.005,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F8F4EB",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F8F4EB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F8F4EB",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_5857_34274",
    x1: 11.128,
    x2: 8.237,
    y1: 12.342,
    y2: 9.665,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F8F4EB",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F8F4EB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F8F4EB",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_5857_34274",
    x1: 4.527,
    x2: 6.993,
    y1: 5.976,
    y2: 8.305,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F8F4EB",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F8F4EB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F8F4EB",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_5857_34274",
    x1: 4.527,
    x2: -2.246,
    y1: 5.976,
    y2: 0.6,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F8F4EB",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F8F4EB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F8F4EB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_5857_34274",
    x1: 2.801,
    x2: -0.319,
    y1: 6.96,
    y2: 8.647,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F8F4EB",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F8F4EB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F8F4EB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_5857_34274",
    x1: 9.331,
    x2: 6.212,
    y1: 8.544,
    y2: 5.424,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.025,
    stopColor: "#F8F4EB",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.025,
    stopColor: "#F8F4EB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.419,
    stopColor: "#F8F4EB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.419,
    stopColor: "#F8F4EB",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_5857_34274",
    x1: 21.581,
    x2: 20.029,
    y1: 2.503,
    y2: 3.443,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.053,
    stopColor: "#F8F4EB",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.054,
    stopColor: "#F8F4EB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F8F4EB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F8F4EB",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_5857_34274",
    x1: 22.542,
    x2: 21.037,
    y1: 4.274,
    y2: 5.161,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.316,
    stopColor: "#F8F4EB",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.402,
    stopColor: "#F8F4EB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F8F4EB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F8F4EB",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_5857_34274",
    x1: 28.773,
    x2: 21.055,
    y1: 15.214,
    y2: 5.405,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F8F4EB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.766,
    stopColor: "#F8F4EB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F8F4EB",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_5857_34274",
    x1: 28.773,
    x2: 20.983,
    y1: 15.214,
    y2: 4.461,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F8F4EB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.885,
    stopColor: "#F8F4EB",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear_5857_34274",
    x1: 17.978,
    x2: 9.62,
    y1: 6.743,
    y2: 12.38,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.067,
    stopColor: "#F8F4EB",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.332,
    stopColor: "#F8F4EB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.681,
    stopColor: "#F8F4EB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F8F4EB",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint11_radial_5857_34274",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(.36726 -5.66373 5.66369 .36726 17.523 1.345)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.33,
    stopColor: "#F8F4EB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.543,
    stopColor: "#F8F4EB",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint12_radial_5857_34274",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "rotate(-130.321 10.29 -3.224)scale(2.79106)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F8F4EB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.326,
    stopColor: "#F8F4EB",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint13_radial_5857_34274",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "rotate(-130.527 10.604 -3.064)scale(3.41806)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F8F4EB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.086,
    stopColor: "#F8F4EB",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint14_radial_5857_34274",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "rotate(-41.92 10.678 -19.26)scale(2.6904)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F8F4EB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.477,
    stopColor: "#F8F4EB",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint16_radial_5857_34274",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(3.4487 3.34828 -9.44089 9.72419 11.505 13.101)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.224,
    stopColor: "#F8F4EB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.766,
    stopColor: "#F8F4EB",
    stopOpacity: 0
  })))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgLogoLight);
export default ForwardRef;